import { render, staticRenderFns } from "./OrganizationDialog.vue?vue&type=template&id=32ff4f7d&scoped=true&"
import script from "./OrganizationDialog.vue?vue&type=script&lang=js&"
export * from "./OrganizationDialog.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationDialog.vue?vue&type=style&index=0&id=32ff4f7d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ff4f7d",
  null
  
)

export default component.exports